import { BigNumber } from '@ethersproject/bignumber'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { isRobinhoodChain } from 'config/constants/chains'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { AppState } from '../state'
import useCurrentBlockTimestamp from './useCurrentBlockTimestamp'

// Combines the block timestamp with the user's TTL.
// Robinhood chains use local Unix time as a fallback when the block
// timestamp hook does not support the custom chain.
export default function useTransactionDeadline(): BigNumber | undefined {
  const ttl = useSelector<AppState, number>(
    (state) => state.user.userDeadline,
  )
  const blockTimestamp = useCurrentBlockTimestamp()
  const { chainId } = useActiveWeb3React()

  return useMemo(() => {
    if (!ttl) return undefined

    if (blockTimestamp) {
      return blockTimestamp.add(ttl)
    }

    if (isRobinhoodChain(chainId)) {
      const currentUnixTimestamp = Math.floor(Date.now() / 1000)
      return BigNumber.from(currentUnixTimestamp).add(ttl)
    }

    return undefined
  }, [blockTimestamp, chainId, ttl])
}
